import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem("cookie_consent", "accepted");
    setVisible(false);
  };

  const preferences = () => {
    localStorage.setItem("cookie_consent", "essential_only");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div data-testid="cookie-banner" className="fixed bottom-0 left-0 right-0 z-50 p-4 sm:p-6 bg-[#141420] border-t border-white/10 shadow-2xl shadow-black/50">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex-1">
          <h3 className="text-white font-semibold text-base mb-1">We use cookies</h3>
          <p className="text-white/50 text-sm leading-relaxed">
            We use cookies and other tracking technologies to enhance your experience on our website for analytical purposes, advertising, and marketing. By clicking "Continue to Site", you consent to our use of cookies as explained in our{" "}
            <Link to="/privacy" className="text-purple-400 underline hover:text-purple-300 transition">Privacy Policy</Link>.
          </p>
        </div>
        <div className="flex gap-3 flex-shrink-0">
          <button
            data-testid="cookie-accept"
            onClick={accept}
            className="bg-purple-600 hover:bg-purple-500 text-white px-6 py-2.5 rounded-full text-sm font-medium transition"
          >
            Continue to Site
          </button>
          <button
            data-testid="cookie-preferences"
            onClick={preferences}
            className="bg-white/10 hover:bg-white/15 text-white px-6 py-2.5 rounded-full text-sm font-medium transition border border-white/10"
          >
            Essential Only
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
